module.exports = __webpack_public_path__ + "img/agentNmae.c1cb7798.svg";